import axios from 'axios'

// Small in-memory cache for paginated GET requests so that moving between
// pages with the ‹ › arrows is instant. Entries expire after TTL_MS, identical
// in-flight requests are shared, and callers can clear a URL prefix after
// data changes (create / delete).
const TTL_MS = 60 * 1000
const cache = new Map() // url -> { time, promise }

export const fetchPage = (url, headers) => {
  const hit = cache.get(url)
  if (hit && Date.now() - hit.time < TTL_MS) return hit.promise

  const promise = axios
    .get(url, { headers })
    .then(res => res.data)
    .catch(err => {
      cache.delete(url) // don't cache failures
      throw err
    })

  cache.set(url, { time: Date.now(), promise })
  return promise
}

// Warm the cache for a page without waiting for it
export const prefetchPage = (url, headers) => {
  fetchPage(url, headers).catch(() => {})
}

export const clearPages = prefix => {
  for (const key of cache.keys()) {
    if (key.startsWith(prefix)) cache.delete(key)
  }
}
